import $api from '../../utils/api.js'


const state = () => ({
    category: {
        total: 0,
        per_page: 2,
        from: 1,
        to: 0,
        current_page: 1
    },
    sorting: {
        num:10,
        search: '',
        offset: 4,
        sort:'asc',
        placeholder:'Search Category'
    },
    formdata:{
        id:'',
        order:'',
        name:'',
        is_active:'1',
        is_show:'1',
    },
    errors:[],
})

const mutations = {
    ASSIGN_DATA(state, payload) {
        state.category = payload
    },
    ASSIGN_FORM(state, payload) {
        state.formdata = payload
    },
    CLEAR_FORM(state) {
        state.formdata = {
            id:'',
            order:'',
            name:'',
            is_active:'1',
            is_show:'1',
        },
        state.errors = []
    },
    CLEAR_CATEGORY(state){
        state.category = {
            total: 0,
            per_page: 2,
            from: 1,
            to: 0,
            current_page: 1
        }
    },
    SET_ERRORS(state, payload) {
        state.errors = payload
    },
}

const actions = {
    getCategory({ commit, state }) {
        return new Promise((resolve) => {
            $api.get(`category-package?page=${state.category.current_page}&paginate=${state.sorting.num}&search=${state.sorting.search}&sort=${state.sorting.sort}`)
            .then((response) => {
                commit('ASSIGN_DATA', response.data)
                resolve(response.data)
            })
        })
    },
    createCategory({ commit }, payload) {
        return new Promise((resolve) => {
            $api.post(`category-package`, payload)
            .then((response) => {
                resolve(response.data)
            })
            .catch((error) => {
                if (error.response.status == 400) {
                    commit('SET_ERRORS', error.response.data.errors)
                }
            })
        })
    },
    editCategory({ commit, state }, payload) {
        return new Promise((resolve) => {
            $api.get(`category-package?type=${state.sorting.type}&id=${payload}`)
            .then((response) => {
                commit('ASSIGN_FORM', response.data)
                resolve(response.data)
            })
        })
    },
    updateCategory({ state,commit }, payload) {
        return new Promise((resolve) => {
            $api.put(`category-package/${state.formdata.id}`, payload.formData)
            .then((response) => {
                resolve(response.data)
            })
            .catch((error) => {
                if (error.response.status == 400) {
                    commit('SET_ERRORS', error.response.data.errors)
                }
            })
        })
    },
    deleteCategory({ dispatch }, payload) {
        return new Promise((resolve) => {
            $api.delete(`category-package/${payload}`)
            .then(() => {
                dispatch('getCategory').then(() => resolve())
            })
        })
    },
    
}

export default {
    namespaced: true,
    state,
    actions,
    mutations
}